import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "bootstrap/dist/css/bootstrap.min.css";

const ToastMessage = ({ type, message, onClose }) => {  
  useEffect(() => {
    if (!message) return;

    const timer = setTimeout(() => {
      onClose(); // Ferme le toast après 3 secondes
    }, 3000);

    return () => clearTimeout(timer); // Nettoyage du timer
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div
      className={`alert alert-${type} position-fixed top-0 end-0 m-3 d-flex align-items-center fade show`}
      role="alert"
      style={{ zIndex: 999999, cursor: "pointer" }}
      onClick={onClose} // Permet de fermer en cliquant
    >
      {type === "success" ? (
        <i className="bi bi-check-circle me-2"></i>
      ) : (
        <i className="bi bi-exclamation-circle me-2"></i>
      )}
      {message}
    </div>
  );
};

ToastMessage.propTypes = {
  type: PropTypes.oneOf(["success", "danger", "warning", "info"]).isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ToastMessage;
